import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Home from "./Home";
import Login from "./Login";
import Register from "./Register";
import Cart from "./Cart";
import Navbar from "./Navbar";
import Product from "./Product";
import Wishlist from "./Wishlist";
import Footer from "./Footer";
import AddProduct from "./AddProduct";
import Checkout from "./Checkout";
import Admin from "./Admin";
import AdminOrders from "./AdminOrders";
import Faqs from "./Faqs";
import Contact from "./Contact";
import About from "./About";
import Privacy from "./Privacy";
import Terms from "./Terms";
import Shipping from "./Shipping";
import Returns from "./Returns";
import ScrollToTop from "./ScrollToTop";
import AdminLogin from "./AdminLogin";
import Success from "./Success";
function Layout() {

  const location = useLocation();

 const isAdminPage =
  location.pathname === "/admin" ||
  location.pathname === "/admin-dashboard" ||
  location.pathname === "/admin-orders";

  return (

    <>

      {/* SHOW ONLY NORMAL PAGES */}
      {!isAdminPage && <Navbar />}

      <ScrollToTop />

      <Routes>

        <Route path="/" element={<Home />} />

        <Route path="/login" element={<Login />} />

        <Route path="/register" element={<Register />} />

        <Route path="/cart" element={<Cart />} />

        <Route path="/checkout" element={<Checkout />} />
<Route path="/success" element={<Success />} />
        <Route path="/product/:id" element={<Product />} />

        <Route path="/wishlist" element={<Wishlist />} />

        <Route path="/add-product" element={<AddProduct />} />

        <Route
  path="/admin"
  element={<AdminLogin />}
/>

<Route
  path="/admin-dashboard"
  element={<Admin />}
/>

        <Route path="/admin-orders" element={<AdminOrders />} />

        <Route path="/faqs" element={<Faqs />} />

        <Route path="/contact" element={<Contact />} />

        <Route path="/about" element={<About />} />

        <Route path="/privacy" element={<Privacy />} />

        <Route path="/terms" element={<Terms />} />

        <Route path="/shipping" element={<Shipping />} />

        <Route path="/returns" element={<Returns />} />

      </Routes>

      {/* FOOTER ONLY NORMAL PAGES */}
      {!isAdminPage && <Footer />}

    </>

  );
}

function App() {

  return (

    <BrowserRouter>

      <Layout />

    </BrowserRouter>

  );
}

export default App;